/**
 * Slug validation + derivation — single frontend source of truth.
 *
 * SLUG_REGEX mirrors the backend SLUG_PATTERN in api/app/schemas/model.py:
 * lowercase alnum + hyphens + dots, starts/ends alphanumeric, ≤64 chars.
 * Change them together.
 */

export const SLUG_REGEX = /^[a-z0-9]([a-z0-9.-]{0,62}[a-z0-9])?$/

/**
 * Derive a valid slug from a display name ("Acme Inc." → "acme-inc").
 *
 * Trims leading/trailing dots AND hyphens after the 64-char slice, so the
 * result always satisfies SLUG_REGEX's must-end-alphanumeric rule.
 */
export function deriveSlug(displayName: string): string {
  return displayName
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9.-]+/g, '-')
    .slice(0, 64)
    .replace(/^[.-]+|[.-]+$/g, '')
}
